import axios from "axios";
import {getOptions} from "../../helpers/api";

export const fieldTasks = {

  getInspectors: (data) => {
    const {params, headers} = getOptions(data);
    return axios.post("/fieldrunner/users", params, headers);
  },

  getAssignedTasks: (data) => {
    const {params, headers} = getOptions(data);
    return axios.post("/fieldrunner/assigned/tasks", params, headers);
  },

  getUnassignedTasks: (data) => {
    const {params, headers} = getOptions(data);
    return axios.post("/fieldrunner/unassigned/tasks", params, headers);
  },

  assignTasks: (data) => {
    const {params, headers} = getOptions(data);
    return axios.post("/fieldrunner/task/assignment", params, headers);
  },

  reAssignTasks: (data) => {
    const {params, headers} = getOptions(data);
    return axios.post("/fieldrunner/task/update", params, headers);
  },

  getReviewTasksList: (data) => {
    const {params, headers} = getOptions(data);
    return axios.post("/review/task/list", params, headers);
  },

  getChecklist: (data) => {
    const {params, headers} = getOptions(data);
    return axios.post("/get/inspection/checklist", params, headers);
  },

  rejectTask: (data) => {
    const {params, headers} = getOptions(data);
    return axios.post("/task/inspection/reject", params, headers);
  },

  approveTask: (data) => {
    const {params, headers} = getOptions(data);
    return axios.post("/task/inspection/approve", params, headers);
  },

  startTask: (data) => {
    const {params, headers} = getOptions(data);
    return axios.post("/start/milestone", params, headers);
  },

  candidateApproval: (data) => {
    const {params, headers} = getOptions(data);
    return axios.post("/checklist/bts/approval", params, headers);
  },

};